<template>
  <div class="note">
    <h1 class="tac mt-20 f20">测评须知</h1>
    <div class="text">
      <div class="text_txt f16">
        <p class="mt-10">
          1.本测评结果不可作为心理、精神疾病诊断的依据。若需要专业诊断，请前往医院精神科或者心理咨询科进行诊断；
        </p>
        <p class="mt-10">
          2.为保证测试的准确性，请根据实际情况如实作答，作答完成后会生成一份专业的测评报告，在“我的-我的测评”中可以查看报告；
        </p>
        <p class="mt-10">
          3.本测试每次下单只能测试一次，若需要测试多次，请再次下单；
        </p>
        <p class="mt-10">
          4.如在测试过程中遇到问题，请添加客服微信brain_assisstant1进行反馈
        </p>
        <P class="mt-10"
          >5.本测试为虚拟服务产品，一经购买，概不退款，请您理解。</P
        >
      </div>
      <div class="Bg_color"></div>
    </div>
    <van-button @click="next()" class="next">我已知悉</van-button>
  </div>
</template>

<script>
export default {
  name: "note",
  data() {
    return {};
  },
  // created() {
  //   if(!localStorage['first']){
  //      location.reload()
  //   }
  //  localStorage['first'] = 1
  // },
  methods: {
    // 跳转到测评详情
    next() {
      localStorage["first"] = "";
      this.$router.push("./detail");
    },
  },
};
</script>

<style lang="less" scoped>
@import "~Style/index.less";
.note {
  .next {
    width: 90%;
    text-align: center;
    line-height: 18px;
    margin-left: 5%;
    border-radius: 25px;
    background-color: #42686e;
    color: white;
    font-size: 18px;
    margin-top: 25px;
  }
  .text {
    position: relative;
    .w(359);
    margin: 0 auto;
    margin-top: 39px;
    height: 420px;
    border: 3px solid #42686e;
    p {
      line-height: 22px;
      margin-top: 20px;
    }
    .text_txt {
      .w(326);
      height: 374px;
      margin-left: 19px;
    }
  }
  .Bg_color {
    position: absolute;
    .w(351);
    height: 420px;
    background: #eceff5;
    z-index: -1;
    left: 13px;
    top: -12px;
  }
}
</style>